import { useEffect } from "react"
import { useInView } from "react-intersection-observer"

import { marketingClient, orderClient, useQuery } from "@trueskin-web/apis"
import { Heading, MobileStickyCta, Seo } from "@trueskin-web/components"
import { Trans, useTranslation } from "@trueskin-web/translations"

import Addresses from "../../components/payment/addresses"
import { Methods } from "../../components/payment/methods"
import TermsAndConditions from "../../components/terms-and-conditions"

import CheckoutOverview from "./components/checkout-overview"

const Payment = () => {
  const { t } = useTranslation()

  useQuery("currentOrderSummary", orderClient.getCurrentSummary)

  const [inViewRef, isInView, inViewEl] = useInView({
    threshold: 0,
  })

  useEffect(() => {
    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM.CART_SUMMARY_PAGE,
    })
  }, [])

  return (
    <div sx={{ maxWidth: "468px", mx: "auto" }}>
      <Seo title={t("Start.Payment.seoTitle")} />
      <div
        data-testid="web-portal-summary-payment"
        sx={{
          mt: 5,
        }}
      >
        <Heading
          sx={{
            mb: 4,
            fontSize: 5,
            lineHeight: "smallerHeading",
          }}
        >
          <Trans i18nKey="Payment.Overview.title" />
        </Heading>

        <CheckoutOverview />

        <Methods ref={inViewRef} />

        <Addresses
          sx={{
            my: 7,
          }}
        />

        <MobileStickyCta
          show={!isInView}
          title={t("Payment.MobileStickyCta.title")}
          onClick={() => {
            window.scrollTo({
              behavior: "smooth",
              top: inViewEl.target.offsetTop - 15,
            })
          }}
        />
      </div>
      <TermsAndConditions />
    </div>
  )
}

export default Payment
